// Modules
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// CSS and assets
import './style.scss';

// Utils
import { useAuth } from '@global/hooks/useAuth';
import analytic from '@global/utils/AdobeAnalytics';

interface IProps {
  isMobile?: boolean;
  setMenuOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UserDropdown: React.FC<IProps> = ({}) => {
  const { t } = useTranslation();
  const { doLogout } = useAuth();

  const logoutHandler = useCallback(() => {
    analytic.dataLayerBtnTracker({
      btnType: 'link',
      btnName: t('header.dropdown.user.logout'),
    });
    analytic.dataLayerForm({
      formName: 'header',
      formEvent: 'LogoutSuccess',
    });
    doLogout();
  }, []);

  return (
    <div className="user-dropdown user-dropdown__logged-in">
      <div className="user-dropdown__selection-box">
        <button className="user-dropdown__logout-btn" onClick={logoutHandler}>
          {t('header.dropdown.user.logout')}
        </button>
      </div>
    </div>
  );
};
